export const minutesLabels = [...Array(60).keys()];

export const secondsLabels = [...Array(60).keys()];
